<template>
  <div :class="`${$root.parent.get('slimView') ? 'card-slim' : ''} ${!chore.get('done') && this.$props.mode !== 'kids' ? 'card  cf0' : 'card  cs1'
  }`" v-if="isVisible" :style="`background-image: ${typeof chore.get('image') == 'string'
    ? 'url(' + chore.get('image') + ')'
    : 'url(/images/chores/chorebg.jpg)'
  };`">
    <div class="overlay"></div>
    <div class="card-header">
      <div>
        <h3>{{ chore.get("name") }}</h3>
        <p v-if="!chore.get('done')">{{ chore.get("description") }}</p>
        <p v-else>🎉 Chore Complete | Tap To Confirm 🎉</p>
      </div>
      <div v-if="chore.get('done')">
        <div class>✅</div>
      </div>
      <div v-else class="fhr fhr-clock"></div>
    </div>
    <div class="card-footer">
      <p>{{ $tc("chore.points", chore.get("points"), { count: chore.get("points") }) }}</p>
      <span v-if="chore.get('repeats') !== '0.0.0.0.0.0.0'" style="text-align: right">
        <span v-for="(day, index) of chore.get('repeats').split('.')" :key="day + index + 'dow'"
          :class="day !== '1' ? 'dayOfWeek ' : 'dayOfWeek dayOfWeek-active'">
          {{
  [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
          ][index][0]
          }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import * as ModernModals from "modern-modals";
export default {
  name: "chore",
  props: ["chore", "mode", "isFuture"],
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    try {
      const chore = this.$props.chore;
      const dayOfWeek = new Date().getDay();
      let schedule = chore.get("repeats").split(".");
      let isVisibleToday =
        chore.get("done") ||
        ((chore.get("repeats") == "0.0.0.0.0.0.0" ||
          schedule[dayOfWeek] == "1") &&
          (typeof chore.get("dateConfirmed") == "undefined" ||
            chore.get("dateConfirmed") !== new Date().toDateString()));
      this.$data.isVisible =
        this.$props.mode == "kids" && chore.get("done")
          ? false
          : (this.$props.isFuture == "yes" && !isVisibleToday) ||
          (this.$props.isFuture !== "yes" && isVisibleToday);
      this._setupLongPress();
    } catch { }
  },
  beforeDestroy() {
    // The long press handlers and its timer belong to this card. Without
    // this they keep running after the card is gone.
    this._teardownLongPress();
  },
  methods: {
    _setupLongPress() {
      this._touchMoved = false;
      this._timer = null;
      this._down = () => {
        const pushLength = Number(new Date());
        if (this._timer) clearInterval(this._timer);
        this._timer = setInterval(() => {
          if (Number(new Date()) - Number(pushLength) >= 250) {
            clearInterval(this._timer);
            this._timer = null;
            if (this._touchMoved) return;
            if (!this.$route.path.includes("kids")) this.removeChore();
          }
        }, 10);
      };
      this._up = (e) => {
        e.stopPropagation();
        this._touchMoved = false;
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
      };
      this._move = () => (this._touchMoved = true);
      this._contextmenu = (e) => e.preventDefault();
      this._attach();
    },
    _attach() {
      const el = this.$el;
      if (!el) return;
      el.addEventListener("mousedown", this._down, false);
      el.addEventListener("touchstart", this._down, true);
      el.addEventListener("mouseup", this._up, false);
      el.addEventListener("touchend", this._up, false);
      el.addEventListener("touchmove", this._move);
      el.addEventListener("contextmenu", this._contextmenu);
    },
    _teardownLongPress() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
      const el = this.$el;
      if (!el || !this._down) return;
      el.removeEventListener("mousedown", this._down, false);
      el.removeEventListener("touchstart", this._down, true);
      el.removeEventListener("mouseup", this._up, false);
      el.removeEventListener("touchend", this._up, false);
      el.removeEventListener("touchmove", this._move);
      el.removeEventListener("contextmenu", this._contextmenu);
    },
    async removeChore() {
      const answer = await ModernModals.prompt(this.$t("pages.parents.deleteChore"));
      if (answer) {
        // Wait for the delete, otherwise the list is reloaded while the
        // chore is still there and it comes back.
        await this.$props.chore.destroy();
      }
      await this.$root.initLoadChores();
    }
  }
};
</script>
